<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="1000px">
      <v-card class="elevation-12">
        <v-toolbar
            color="primary"
            flat
        >
          <v-spacer/>
          <v-toolbar-title >Kayıt formu</v-toolbar-title>
          <v-spacer/>
        </v-toolbar>
        <v-card-text>
           <v-stepper v-model="e6">
            <v-stepper-header>
              <template v-for="(step, n) in steps">
                <v-stepper-step
                    :key="`${n}-step`"
                    :complete="e6 > n"
                    :step="n"
                    :editable="step.editable"
                >
                  {{ step.title }}
                </v-stepper-step>

                <v-divider
                    v-if="n !== steps.length"
                    :key="n"
                ></v-divider>
              </template>

            </v-stepper-header>
            <v-stepper-items>

              <v-stepper-content
                  v-for="(step, n) in steps"
                  :key="`${n}-content`"
                  :step="n"
              >
                <ValidationObserver v-slot="{ invalid }" >
                  <form>
                    <v-card class="mb-12" elevation="0">
                      <v-card-title v-if="$vuetify.breakpoint.smAndDown">{{ step.title }}</v-card-title>

                      <v-row dense>
                        <v-col
                            v-for="(q,i) in step.questions"
                            :key="i"
                            :cols="$vuetify.breakpoint.mdAndUp? q.flex: 12"
                        >
                          <keep-alive>
                            <ValidationProvider v-slot="{ errors }" :name="q.name" :rules="q.rules">
                              <component
                                  :is="'v-' + q.type"
                                  :error-messages="errors"
                                  v-bind="q.attrs"
                                  v-model="registerDetails[q.name]"
                              ></component>
                            </ValidationProvider>

                          </keep-alive>

                        </v-col>
                      </v-row>

                    </v-card>
                    <v-row dense>
                      <v-col>
                        <v-btn v-if="n!==0" color="primary" @click="e6 = n - 1">
                          Geri
                        </v-btn>
                      </v-col>

                      <v-col>

                        <v-btn v-if="n!==steps.length -1" color="secondary" :disabled="invalid" @click="e6 = n + 1">
                          Devam
                        </v-btn>
                        <v-btn v-else color="success" :disabled="invalid" @click="registerStudent_()">
                          Kayıt Ol
                        </v-btn>
                      </v-col>
                    </v-row>
                  </form>
                </ValidationObserver>
              </v-stepper-content>

            </v-stepper-items>
          </v-stepper>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="resetRegister(); $emit('close-register');">Close</v-btn>
        </v-card-actions>
      </v-card>

      <div class="text-center ma-2">
        <v-snackbar v-model="snackbar" :color="snackbarColor">
          {{ snackbarText }}

          <template v-slot:action="{ attrs }">
            <v-btn
                color="pink"
                text
                v-bind="attrs"
                @click="snackbar = false"
            >
              Kapat
            </v-btn>
          </template>
        </v-snackbar>
      </div>

    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex'
import { required, email, max, min, between } from 'vee-validate/dist/rules'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';

extend('required', {
  ...required,
  message: 'Bu alan boş bırakılamaz',
})

extend('max', {
  ...max,
  message: 'Bu alan {length} karakterden daha uzun olmamalı',
})

extend('min', {
  ...min,
  message: 'Bu alan {length} karakterden daha kısa olmamalı',
})

extend('between', {
  ...between,
  message: 'Bu alan {min} karakterden uzun, {max} karakterden kısa olmalı',
})

extend('email', {
  ...email,
  message: 'Email geçerli değil',
})

export default {
  name: 'Register',
  props: {
    dialog: Boolean
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data () {
    return {
      steps: require('@/data/register.json'),
      registerDetails: {},
      GraphqlError: '',
      e6: 0,
      snackbar: false,
      snackbarText: '',
      snackbarColor: '',

    }
  },
  created() {
    this.steps.map(step => step.questions.map(q=> this.registerDetails[q.name] = ''))
  },
  methods: {
    ...mapActions(['registerStudent']),
    registerStudent_(){
      this.GraphqlError = ''
      this.registerStudent(this.registerDetails)
          .catch(err => this.GraphqlError = err)
          .then(() => this.GraphqlError || console.log("Başarılı"))
          .finally(() => {
            if(this.GraphqlError !== ''){
              console.log(this.GraphqlError)
              this.snackbarText = 'Kayıt olunamadı'
              this.snackbarColor = 'error'
            }
            else{
              this.snackbarText = `Kaydınız başarıyla tamamlanmıştır.`
              this.snackbarColor = 'success'

              setTimeout(()=>{this.$emit('close-register'); this.resetRegister();},2000)

            }
            this.snackbar = true
          })


    },

    resetRegister() {
      this.e6 = 0
      this.registerDetails = {}
    }
  }
}
</script>
